import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { Results } from '../../components/Results';
import { selectResults, selectIsSearcherOrSub } from '../../selectors';
import { isFavoritesForAuthorizationEnabled } from '../../selectors/experiments/isFavoritesForAuthorizationEnabled';
import { selectFilters } from '../../selectors/filters';
import { EEntityType, ETabType } from '../../types/filters';
import { EGetFavoriteEntitiesStatus } from '../../types/results';
import { FolderHeaderContainer } from '../FolderHeader';
import { FoldersListContainer } from '../FoldersList';
import { TopBarContainer } from '../TopBar';
import { SavedSearches } from '../SavedSearches';
import { LoadingView } from '../../components/SavedSearches/LoadingView';
import { selectActiveTab } from '../../selectors/activeTab';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';

export function ResultsContainer() {
  const dispatch = useDispatch();
  const results = useSelector(selectResults);
  const { favoriteEntityType } = useSelector(selectFilters);
  const isSearcherOrSub = useSelector(selectIsSearcherOrSub);
  const { activeTab, isInitialized } = useSelector(selectActiveTab);
  const isFoldersListVisible = favoriteEntityType !== EEntityType.Newbuilding && activeTab !== ETabType.JK;
  const favoritesForAuthorizationEnabled = useSelector(isFavoritesForAuthorizationEnabled);

  React.useEffect(() => {
    if (favoritesForAuthorizationEnabled) {
      dispatch(requestAuthentication());
    }
  }, [dispatch, favoritesForAuthorizationEnabled]);

  if (results.status === EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  if (!isInitialized) {
    return <LoadingView />;
  }

  //если выбран таб "Поиски"
  if (activeTab === ETabType.SavedSearches) {
    return (
      <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
        <SavedSearches />
      </Experiment>
    );
  }

  return (
    <Results
      results={results}
      isSearcherOrSub={isSearcherOrSub}
      foldersList={isFoldersListVisible && <FoldersListContainer />}
      foldersHeader={isFoldersListVisible && <FolderHeaderContainer />}
      topBar={<TopBarContainer />}
      isFavoritesForAuthorizationEnabled={favoritesForAuthorizationEnabled}
    />
  );
}
